import { useEffect } from "react";
import { use_store } from "../store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";

export const Message = () => {
  const { message, set_message } = use_store();

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        set_message(null);
      }, 8000);

      return () => clearTimeout(timer);
    }
  }, [message, set_message]);

  if (!message) return null;

  return (
    <div className="fixed bottom-[12px] right-[12px] bg-green-600 text-white p-[28px] rounded-[4px] max-w-[400px] shadow-lg">
      <button
        onClick={() => set_message(null)}
        className="absolute top-[8px] right-[8px] text-white hover:text-gray-200 transition-colors cursor-pointer"
      >
        <FontAwesomeIcon
          icon={faTimes}
          className="text-[24px] text-white hover:opacity-80"
        />
      </button>
      <p className="pr-[24px] smallt">{message}</p>
    </div>
  );
};
